import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomSelectedOptions from "../CommonComponents/CustomSelectedOptions";
import { getdevicelist } from "../../Restclient/datacollection";
import { useSelector } from "react-redux";

export default function EnergyAccountingConfiguration() {
  const { theme } = useContext(ThemeContext);
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [selectedDevicesList, setSelectedDevicesList] = React.useState([]);

  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [devicelist, setDevicelist] = useState([]);

  useEffect(() => {
    getdevicelist(getdevicelistcallback);
  }, []);

  function getdevicelistcallback(res) {
    let data = [];
    res.map((_val, index) => {
      data = [...data, res[index].deviceName];
    });
    setDevicelist(data);
  }

  const handleCloseAddForm = () => {
    setRequired(0);
    setSaveStatus(0);
    // setAssetInfo({organizationId:"",projectId:"",id:"",data:{assetName:"",serialNo:"",description:"",/*commissionDate:"",decommissionDate:"",*/associatedDevices:[]}})
  };

  const handleSaveAddForm = () => {
    // this is to be done
  };

  function handleSelectedOption(selected) {
    setSelectedDevicesList([...selected]);
  }

  function handleRemoveOption(selectedValue) {
    const temp = selectedDevicesList.filter(
      (_value, index) => index !== selectedValue,
    );
    setSelectedDevicesList(temp);
  }

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box" }}
    >
      <Box
        sx={{
          padding: "0px",
          height: "calc(100% - 0px)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            padding: "0px",
            width: "100%",
            height: "7%",
            boxSizing: "border-box",
            display: "flex",
            gap: "8px",
          }}
        >
          <Box sx={{ flexGrow: 1 }}></Box>
          {required === 1 ? (
            <>
              <Typography sx={{ color: "#DC272D" }}>
                required fields to must be filled
              </Typography>
            </>
          ) : (
            <></>
          )}
          {saveStatus !== 0 ? (
            <>
              <Typography
                sx={{
                  color:
                    saveStatus === 1
                      ? theme === "dark"
                        ? "#C1C1C1"
                        : "#3C3C3C"
                      : "#DC272D",
                }}
              >
                {saveStatus === 1 ? "Saved Successfully!" : "Save Failed"}
              </Typography>
            </>
          ) : (
            <></>
          )}
          <CustomCancelButton
            onClick={handleCloseAddForm}
            disabled={true}
            buttonText={"Cancel"}
          ></CustomCancelButton>
          {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}

          <CustomButton
            /*id={assetInfo.id}*/ onClick={handleSaveAddForm}
            disabled={true}
            buttonText={"Save"}
            width={"12px"}
          />
        </Box>
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          <Box
            className="config-form-box"
            sx={{
              padding: "4px 4px 4px 0px",
              width: "100%",
              boxSizing: "border-box",
              marginTop: "12px",
            }}
          >
            <Typography
              style={{
                fontSize: "18px",
                fontWeight: 400,
                color: "var(--GreyVariation_2)",
                width: "224px",
              }}
            >
              Groups
            </Typography>
            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                width: "calc(100% - 224px)",
                height: "400px",
                overflow: "auto",
              }}
            >
              {/* <Box sx={{flexDirection:'column',display:'flex',width:"66%",height:'100%',overflow:'auto'}}>
                                <Box style={{display: 'flex', flexDirection: 'column',width:"100%",boxSizing:"border-box",maxWidth:'100%'}}>
                                    <Box sx={{display:'flex',flexDirection:'row',width:"100%",boxSizing:"border-box",}}>
                                        <Box sx={{flexGrow:1}}/>
                                            <Button
                                            onClick={handleAdd}
                                            type="text"
                                            style={{
                                                marginBottom: "0px",
                                                marginTop:"0px",
                                                color:"#008CD7",
                                                alignSelf:"end",
                                                justifySelf:"end"
                                            }}
                                            >
                                            <LK_Add color='#008CD7' width={"24px"} height={"24px"}/>
                                            </Button>
                                            {hasSelected && operation==0?
                                            <Button
                                                onClick={()=>setOperation(1)}
                                                type="text"
                                                style={{
                                                marginRight:'auto',
                                                marginBottom: 16,
                                                color:"#008CD7"
                                                }}
                                            >
                                                <LK_Delete color='#008CD7' width={"32px"} height={"32px"}/>
                                            </Button>
                                            :
                                            <></>
                                            }
                                            {operation==1?
                                            <>
                                                {/* <Typography>Are you sure you want to delete selected items? </Typography> *}
                                                <Button
                                                    onClick={handleDelete}
                                                    style={{
                                                    marginBottom: 16,
                                                    color:"#008CD7"
                                                    }}
                                                >
                                                    Yes
                                                </Button>  
                                                <Button
                                                onClick={handleDeleteCanel}
                                                style={{
                                                    marginBottom: 16,
                                                    color:"#008CD7"
                                                }}
                                                >
                                                No
                                                </Button>
                                            </>
                                            :
                                            <></>
                                            }
                                        <Box sx={{display:'flex', flexDirection:'row',width:'30%',fontSize:"16px",fontFamily:"Roboto",margin:"0px",alignSelf:"center" ,gap:"20px", alignItems:"center"}}>
                                        <CustomTextField id={'negative-feedback'} onChange={handleSearchText} defaultValue={ifsearching==0?"search":search.searchText} width={180}/> 
                                        <CustomDropDown options={filter} onChange={handleFilterSelected} defaultValue={ifsearching==0?"":search.filterSelected} width={"150px"}></CustomDropDown>   
                                        <Button onClick={handleSearchClick} style={{ fontSize: '12px',width:"40px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-24px",padding:0}}><LK_Search color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button> 
                                        {ifsearching==1?<Button onClick={handleSearchCancel} style={{ fontSize: '12px',width:"10px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-44px",padding:0}}><LK_Close color='var(--LK_BrandBlue)' width={"24px"} height={"24px"}/></Button>:<></> }
                                        </Box>
                                    </Box>
                                    {/* <Form form={form} component={false} style={{width:"100%",boxSizing:"border-box",maxWidth:'100%'}}>
                                        <ConfigProvider
                                            theme={{
                                                token: {
                                                    borderRadius: 0,
                                                    colorText: 'var(--grey-variation-tablerowsLK)',
                                                    colorTextHeading: 'var(--grey-variation-tablerowsLK)',
                                                    //fontFamily: props.widgetprop.props.extended.tablerows.fonttype,
                                                    fontSizeIcon: 10,
                                                    //colorBgContainer: '#EDEFEE',
                                                    lineHeight: 1.5,
                                                    // width:'100%'
                                                },
                                                components: {
                                                    Table: {
                                                        borderColor: 'var(--table-boarder-line)',
                                                        headerBg: "var(--SecondaryBackground)",
                                                        headerSplitColor: "var(--SecondaryBackground)",
                                                        rowHoverBg: 'var(--primary-background-color-hover)',
                                                        stickyScrollBarBg: 'var(--primary-background-color),var(--secondary-background)',
                                                        stickyScrollBarBorderRadius: 0,
                                                        //cellFontSizeSM: props.widgetprop.props.extended.tablerows.fontsize,
                                                        cellPaddingBlockSM: '7.05px',
                                                        cellPaddingInlineSM: '7.1px',
                                                        width:'100%',
                                                        maxWidth:'100%',
                                                        boxSizing:"border-box",
                                                    },
                                                },
                                            }}
                                            style={{width:"100%",boxSizing:"border-box",maxWidth:'100%'}}
                                        >
                                        <Table
                                            components={
                                                {
                                                body: {
                                                    cell: EditableCell,
                                                },
                                                }
                                            }
                                            rowSelection={rowSelection}
                                            bordered={false}
                                            tableLayout="fixed"
                                            size='small'
                                            pagination={false}
                                            style={{
                                                marginLeft: "2px",
                                                marginRight: "2px",
                                                marginTop: 0,
                                                marginBottom: 0,
                                                //height: "200px",
                                                // width: 'calc(100% - 4px)',
                                                width: '99%',
                                                maxWidth:'100%',
                                                boxSizing:"border-box",
                                                tableLayout:'fixed',
                                                backgroundColor: '#EDEFEE',
                                            }}
                                            rowClassName={() => 'editable-row'}
                                            dataSource={ifsearching==0?activeParameter:searchList}
                                            columns={mergedColumns}
                                            scroll={{
                                                y: '600px',
                                            }}
                                            notFoundContent={"No Match Found"}
                                            locale={{ emptyText: (<span> no match found
                                                {/* <Button>do something</Button> */}
              {/* <img src="https://www.baidu.com/img/bd_logo1.png" /> *}
                                                </span>)
                                            }}
                                        />
                                        </ConfigProvider>
                                    </Form> *}
                                </Box>
                            </Box>                     */}
              <Box
                sx={{
                  flexDirection: "column",
                  display: "flex",
                  width: "34%",
                  height: "100%",
                  overflow: "auto",
                }}
              >
                <Typography
                  style={{
                    fontSize: "18px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_2)",
                    width: "100%",
                  }}
                >
                  Asset
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginTop: "16px",
                    boxSizing: "border-box",
                  }}
                >
                  <CustomMultiselectWithCheckbox
                    options={devicelist}
                    selecteddata={selectedDevicesList}
                    onChange={handleSelectedOption}
                    maxlimit={25}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      padding: "16px 0px",
                      alignSelf: "start",
                      alignItems: "end",
                    }}
                  >
                    {selectedDevicesList.length > 0 ? (
                      <CustomSelectedOptions
                        selectedOptions={selectedDevicesList}
                        onClick={handleRemoveOption}
                      ></CustomSelectedOptions>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
